import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '@mui/material/Avatar';
import CheckIcon from '@mui/icons-material/Check';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const WizardStepper = ({
  currentStepIndex = 0,
  steps = [],
  onBack = null,
  borderRadius = null,
  hideTitles = false,
}) => {
  return (
    <Box style={{width: '100%'}}>
      <Box 
        style={{
          width: '100%',
          // display: 'flex', 
          // flexGrow: 1,
          borderRadius,
          backgroundColor: '#F5F5F5',
        }}
      >
        <Stack 
          direction="row"
          spacing={0.5}
          padding={2} 
          alignItems="center"
          justifyContent='center'
          flexGrow={1}
        >
          {steps.map((step, index) => (
            <Stack 
              key={index} 
              direction="column" 
              spacing={1} 
              alignItems="center"
              style={{flex: '0 1 90px', minWidth: 0}}
            >
              <Avatar
                sx={{
                  bgcolor: index === currentStepIndex ? 'primary.main' : (index < currentStepIndex ? 'success.main' : 'white'),
                  color: index === currentStepIndex ? 'primary.contrastText' : (index < currentStepIndex ? 'white' : 'text.primary'),
                }}
              >
                {
                  currentStepIndex > index 
                  ? <CheckIcon />
                  : <Typography fontWeight='bold'>{index + 1}</Typography>
                }
              </Avatar>
              {!hideTitles && <Typography variant="caption">{step.label}</Typography>}
            </Stack>
          ))}
        </Stack>
      </Box>
      <Box style={{minHeight: '25px'}}>
        {!!onBack && 
          <Button
            onClick={onBack}
            size='small'
            startIcon={<ChevronLeftIcon />}
          >
            Back
          </Button>
        }
      </Box>
    </Box>
  );
};

WizardStepper.propTypes = {
  currentStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.shape({
    Component: PropTypes.elementType.isRequired,
  })).isRequired,
};

export default WizardStepper;